import React from 'react';
import { Box, Container, Typography, Stack, useTheme, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';
import herobg from '../assets/hero-bg.png';
import herobgMobile from '../assets/hero-bg-mobile.png';
import appStore from '../assets/app_store.svg';
import playStore from '../assets/play_en.png';

const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const backgroundImage = isMobile
    ? herobgMobile
    : herobg;

  return (
    <Box
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: { xs: '100vh', md: '80vh' },
        display: 'flex',
        alignItems: 'center',
        color: '#fff',
        position: 'relative',
        px: 2,
      }}
    >
      {/* Overlay for readability */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to right, rgba(0,0,0,0.6) 30%, rgba(0,0,0,0.2) 80%)',
          zIndex: 1,
        }}
      />

      <Container sx={{ zIndex: 2 }}>
        <Box
          sx={{
            maxWidth: 600,
            color: '#fff',
            textShadow: '1px 1px 3px rgba(0,0,0,0.6)',
            textAlign: { xs: 'center', md: 'left' },
            mx: { xs: 'auto', md: '0' },
          }}
        >
          <Typography variant="h2" component="h1" sx={{ mb: 2 }}>
            MindMapper AI
          </Typography>
          <Typography variant="h6" sx={{ mb: 4 }}>
            Explore your dreams and track your mindfulness journey with your AI-powered dream companion.
          </Typography>

          {/* Store Buttons as Images */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems={{ xs: 'center', md: 'flex-start' }}
          >
            <Box
              component="a"
              href="https://apps.apple.com/your-app-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src={appStore}
                alt="Download on App Store"
                sx={{
                  height: 60,
                  width: 180,
                  transition: 'transform 0.3s',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                }}
              />
            </Box>

            <Box
              component="a"
              href="https://play.google.com/store/apps/details?id=com.mindmapper.mindmapperai"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src={playStore}
                alt="Get it on Google Play"
                sx={{
                  height: 60,
                  width: 180,
                  transition: 'transform 0.3s',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                }}
              />
            </Box>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;
